import {
  DeleteUserRequestParams,
  DeleteUserResponse,
  GetUsersResponse,
  PutUserRequestBody,
  PutUserRequestParams,
  PutUserResponse,
} from '@brilltek42/template-types'
import {
  MutationFunction,
  QueryFunction,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'

import { API } from '@/utils/API'

import { useAPI } from './useAPI'

export const useUsers = () => {
  const queryClient = useQueryClient()

  const { request } = useAPI()

  const apiRoute = API.routes.user

  const getUsersData: QueryFunction<GetUsersResponse> = async () => {
    const { data } = await request<GetUsersResponse, never, never>(
      'get',
      apiRoute.list,
    )

    return data
  }
  const usersDataQuery = useQuery({
    queryKey: ['users'],
    queryFn: getUsersData,
  })

  const putUserData: MutationFunction<
    PutUserResponse,
    { data: PutUserRequestBody; userId: PutUserRequestParams['id'] }
  > = async ({ data, userId }) => {
    const { data: response } = await request<
      PutUserResponse,
      PutUserRequestBody,
      PutUserRequestParams
    >('put', apiRoute.update(userId), {
      params: { id: userId },
      data,
    })
    return response
  }
  const updateUserQuery = useMutation({
    mutationKey: ['update user'],
    mutationFn: putUserData,
    onSuccess: () => {
      queryClient.invalidateQueries(['users'])
    },
  })

  const deleteUser: MutationFunction<
    DeleteUserResponse,
    { userId: DeleteUserRequestParams['id'] }
  > = async ({ userId }) => {
    const { data: response } = await request<DeleteUserResponse>(
      'delete',
      apiRoute.delete(userId),
      {
        params: { id: userId },
      },
    )

    return response
  }
  const deleteUserQuery = useMutation({
    mutationKey: ['delete user'],
    mutationFn: deleteUser,
    onSuccess: () => {
      queryClient.invalidateQueries(['users'])
    },
  })

  return {
    query: usersDataQuery,
    update: updateUserQuery,
    delete: deleteUserQuery,
  }
}
